"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Actions;
(function (Actions) {
    Actions["logIn"] = "login.logIn";
    Actions["logOut"] = "login.logOut";
    Actions["error"] = "login.error";
    Actions["getUser"] = "login.getUser";
    Actions["getUserResult"] = "login.getUserResult";
    Actions["setAccessToken"] = "login.setAccessToken";
})(Actions = exports.Actions || (exports.Actions = {}));
function login(history) {
    return {
        type: Actions.logIn,
        history: history
    };
}
exports.login = login;
function logout(user) {
    return {
        type: Actions.logOut,
        user: user
    };
}
exports.logout = logout;
function getLoggedInUser() {
    return {
        type: Actions.getUser
    };
}
exports.getLoggedInUser = getLoggedInUser;
function getLoggedInUserSucceeded(user) {
    return {
        type: Actions.getUserResult,
        user: user
    };
}
exports.getLoggedInUserSucceeded = getLoggedInUserSucceeded;
function setAccessToken(token) {
    return {
        type: Actions.setAccessToken,
        token: token
    };
}
exports.setAccessToken = setAccessToken;
//# sourceMappingURL=login.js.map